import { writable } from 'svelte/store';
import { getLanguage, getUrlParam } from '../helpers/url';
import { isDefinedNotNull } from '../helpers/common';
import V3Factory from '../helpers/V3';
import { industryCategoryGroup, noImage, OAshortname, obxEndpoint, } from '../helpers/consts';
import { mapCenter } from '../helpers/map';
const onReqServiceStore = writable([]);
const isLoading = writable(false);
const serviceCount = writable(0);
const serviceDetailStore = writable([]);
const V3 = V3Factory(obxEndpoint, OAshortname, OAshortname);
let pageNumber = 0;
let pagingToken = '';
let cachedCriteria;
function withComma(value) {
    if (value) {
        return `, ${value}`;
    }
    return '';
}
function cacheCriteria(criteria) {
    if (criteria) {
        cachedCriteria = criteria;
    }
    else {
        criteria = cachedCriteria;
    }
    return criteria;
}
function getRequest(criteria, getNextPage = false) {
    const filteredDate = criteria.Date || new Date();
    const defaultAvailability = {
        MergeMethod: 1,
        Window: {
            StartDate: filteredDate,
            Size: 42,
        },
    };
    const language = `${getLanguage() || 'ja'}-JP`;
    let request = {
        Language: `${language}`,
        Output: {
            CommonContent: {
                All: true,
            },
            Settings: true,
            Features: true,
            Rating: true,
            Availability: {
                StartDate: filteredDate,
                NumberOfDays: 7,
                MergeMethod: 2,
                LowestRateOnly: true,
            },
            Reviews: {
                IncludeFullDescription: true,
                IncludeShortReview: true,
                MaxReturnCount: 10,
                MaxReturnCountSpecified: true,
            },
            AdvancedContent: true,
        },
        Paging: {
            PageNumber: pageNumber,
            PageSize: 12,
        },
    };
    if (getNextPage) {
        request.Paging.Token = pagingToken;
    }
    else {
        request = Object.assign(Object.assign({}, request), { Filter: {
                Type: 'Service',
                MustBeInAdCampaign: true,
                MustBeInDealCampaign: false,
                Bookability: {
                    BlockUnavailableResults: false,
                    GuestsCapability: null,
                    IncludeOnRequest: true,
                    IsBookable: true,
                    NightsCapability: null,
                },
            }, Campaign: {
                AdCampaignCode: '',
                DealCampaignCode: '',
            } });
    }
    //return early;
    if (!criteria)
        return request;
    if (criteria.Id) {
        request.Filter.Ids = [criteria.Id];
        request.Output.Availability.LowestRateOnly = false;
        request.Output.Children = {
            Output: {
                CommonContent: {
                    All: true,
                },
                Features: true,
                Rating: true,
                Reviews: {
                    IncludeFullDescription: true,
                    IncludeShortReview: true,
                    MaxReturnCount: 10,
                    MaxReturnCountSpecified: true,
                },
                Availability: {
                    StartDate: filteredDate,
                    NumberOfDays: 7,
                    MergeMethod: 2,
                    FlagCampaign: true,
                },
            },
            Children: {
                Filter: {
                    Ids: null,
                    Type: 4,
                },
            },
        };
        if (isDefinedNotNull(criteria.Night) && !getNextPage) {
            request.Filter.Bookability.NightsCapability = criteria.Night;
        }
        if (isDefinedNotNull(criteria.Guest) && !getNextPage) {
            request.Filter.Bookability.GuestsCapability = criteria.Guest;
        }
    }
    else {
        request.Sorting = [
            {
                By: criteria.Sort.split('-')[0],
                Direction: criteria.Sort.split('-')[1],
                PositionOfNull: 'PreferenceBottom',
            },
            {
                By: 'Default',
                Direction: 'Ascending',
            },
        ];
        if (!getNextPage) {
            request.Availability = criteria.Availability || defaultAvailability;
        }
        if (isDefinedNotNull(criteria.Bookability) && !getNextPage) {
            request.Filter.Bookability = criteria.Bookability;
        }
        if (isDefinedNotNull(criteria.IndustryCategoryGroups) && !getNextPage) {
            request.Filter.TagCriteria = {
                IndustryCategoryGroups: criteria.IndustryCategoryGroups,
            };
        }
        if (isDefinedNotNull(criteria.Name) && !getNextPage) {
            request.Filter.Names = ['%' + criteria.Name + '%'];
        }
    }
    return request;
}
async function search(criteria = null, getNextPage = false, getProducts = false) {
    /* Nara custom logic */
    const selectedType = getUrlParam('type');
    if (selectedType && selectedType === industryCategoryGroup.isRestaurant) {
        //change distributor
        V3.setDistributor('NaratabiB');
    }
    /* Nara custom logic */
    criteria = cacheCriteria(criteria);
    if (!getNextPage) {
        //empty store
        onReqServiceStore.set([]);
        pageNumber = 0;
    }
    isLoading.set(true);
    //increment page number
    pageNumber++;
    const response = await V3.search(getRequest(criteria, getNextPage));
    const services = prepare(response.Entities);
    let products = [];
    if (response.Entities.length > 0 && criteria.Id) {
        products = prepare(response.Entities[0].Children, false);
    }
    serviceCount.set(response.Paging.NumberOfResults);
    if (getNextPage) {
        //concatenate services
        onReqServiceStore.update((value) => {
            return [...value, ...services];
        });
    }
    else {
        //replace services
        if (!getProducts) {
            onReqServiceStore.set(services);
        }
        //set paging token
        pagingToken = response.Paging.Token;
    }
    serviceDetailStore.set(products);
    isLoading.set(false);
}
function prepare(services, parent = true) {
    return services.map(function (service, index) {
        return {
            Id: service.Id,
            Name: service.Name,
            Thumbnail: service.Images && service.Images.length
                ? service.Images[0].Url
                : noImage,
            Images: service.Images && service.Images.length
                ? service.Images.map((img) => img.Url)
                : [noImage],
            Code: service.Code,
            Desc: service.LongDescription,
            Rating: service.Rating,
            MinimumStayDuration: service.MinimumStayDuration,
            LongDesc: service.LongDescription,
            Price: Math.round(service.Availability.Calendar.LowestRate),
            Phone: service.MainPhone
                ? service.MainPhone.FullPhoneNumberLocalised
                : null,
            Fax: service.Facsimile || '',
            Website: service.Website,
            PublicEmail: service.PublicEmail,
            OnRequestOnly: service.OnRequestOnly,
            Address: service.PhysicalAddress
                ? service.PhysicalAddress.Line1 +
                    withComma(service.PhysicalAddress.Line2) +
                    withComma(service.PhysicalAddress.City) +
                    withComma(service.PhysicalAddress.PostCode)
                : null,
            Geocode: {
                latitude: service.HasGeocodes
                    ? service.Geocodes[0].Geocode.Latitude
                    : mapCenter.lat + index * 0.2,
                longitude: service.HasGeocodes
                    ? service.Geocodes[0].Geocode.Longitude
                    : mapCenter.lng + index * 0.2,
            },
            Type: service.IndustryCategoryGroups[0],
            TypeName: getTypeName(service.IndustryCategoryGroups[0]),
        };
    });
}
function getTypeName(type) {
    let name = '';
    switch (type) {
        case 0:
            name = 'Accommodation';
            break;
        case 1:
            name = 'Activity';
            break;
        case 2:
            name = 'Restaurant';
            break;
        case 3:
            name = 'Produce';
            break;
        default:
            name = 'Accommodation';
    }
    return name;
}
function getNextPage() {
    search(null, true);
}
let store;
export default store = {
    search,
    getNextPage,
    data: {
        subscribe: onReqServiceStore.subscribe,
        serviceDetail: { subscribe: serviceDetailStore.subscribe },
        isLoading: { subscribe: isLoading.subscribe },
        count: { subscribe: serviceCount.subscribe },
    },
};
